import { useMutation } from '@tanstack/react-query';

export interface UseContactMutationInput {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  message: string;
}

export const useContactForm = () => {
  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: async ({
      firstName,
      lastName,
      phone,
      email,
      message,
    }: UseContactMutationInput) => {
      // const url = new URL('https://api.cal.com/v2/slots/available');
      const url = new URL(import.meta.env.VITE_CONTACT_API_ENDPOINT);
      url.searchParams.append('apiKey', import.meta.env.VITE_CONTACT_API_KEY);
      url.searchParams.append('firstName', firstName);
      url.searchParams.append('lastName', lastName);
      url.searchParams.append('phone', phone);
      url.searchParams.append('email', email);
      url.searchParams.append('message', message);

      return fetch(url, {
        method: 'POST',
      });
    },
  });

  return {
    sendContact: (data: UseContactMutationInput) => mutate(data),
    isPending,
    isError,
    isSuccess,
  };
};
